import { mapGetters, mapActions } from "vuex";

export const mapHelperEnterprise = {
  ...mapGetters([
    "getDrawerEnterprise",
    "getBalanceEnterprise",
    "getConfirmCreditWalletEnterprise",
    "getBankToTransferEnterprise",
    "getAmountToSetEnterprise",
    "getAmountToSetWalletEnterprise",
    "getNameToTransferEnterprise",
    "getCloseSetCreditWalletEnterprise",
    "getBanckAccountEnterprise",
    "getCloseSetTransWalletEnterprise",
    "getConfirmTransWalletEnterprise",
    "getTransactionToStoryWalletEnterprise",
    "getDataSetAfterEnterprise",
    "getUserNameEntity",
    "getNIF",
    "getAvatar",
    "getEntityAddress",
    "getEntityCellphone",
    "getEntityTelephone",
    "getOwnerFullName",
    "getOwnerFirstName",
    "getCategoryInCache",
    "getAllETransactions",
    "getInvoiceStatusInStore",
    "getInvoiceOpenInStore",
    "getInvoicePaidInStore",
    "getInvoiceDisputeInStore",
    "getInvoiceHistoric",
    "getBalanceReport",
    "getChartReportEnt",
    "getMessageToRequestReport",
    "getNameToRequestReport",
  ]),
  ...mapActions({
    // setLogout: "logout"
  })
};
